import React from 'react';
import style from './recipe.module.css';

function Footer(props) {
    return (
        <footer className={style.footer} >Created by < a href="https://www.saffataziz.site/"> Saffat Aziz</a></footer>
    );
}

export default Footer;
